const normalizeStatus = (status) => String(status || "").trim().toLowerCase();

const PRESENTATIONS = {
  job: {
    not_started: {
      label: "Reconhecimento Pendente",
      description: "O reconhecimento ainda nao foi iniciado.",
      nextAction: "Aguardar a decisao administrativa.",
      tone: "pending",
      terminal: false,
    },
    pending: {
      label: "Reconhecimento Pendente",
      description: "A foto aguarda processamento.",
      nextAction: "Aguardar a conclusao do reconhecimento.",
      tone: "pending",
      terminal: false,
    },
    processing: {
      label: "Processando Reconhecimento",
      description: "A foto esta sendo analisada.",
      nextAction: "Aguardar a conclusao do reconhecimento.",
      tone: "processing",
      terminal: false,
    },
    completed: {
      label: "Reconhecimento Processado",
      description: "O resultado persistido esta disponivel para a proxima etapa administrativa.",
      nextAction: "Consultar o resultado e a decisao administrativa aplicavel.",
      tone: "completed",
      terminal: true,
    },
    failed: {
      label: "Falha no Reconhecimento",
      description: "O arquivo foi preservado e exige avaliacao administrativa.",
      nextAction: "ADMIN pode reprocessar, remover ou classificar como foto geral apos inspecao.",
      tone: "failed",
      terminal: true,
      adminOnly: true,
    },
    skipped: {
      label: "Ignorado",
      description: "O reconhecimento atingiu o tempo limite; o arquivo foi preservado.",
      nextAction: "ADMIN pode reprocessar manualmente.",
      tone: "skipped",
      terminal: true,
      adminOnly: true,
    },
  },
  photo: {
    pending: {
      label: "Reconhecimento Pendente",
      description: "A fonte interna esta pronta, mas o reconhecimento ainda nao foi autorizado.",
      nextAction: "ADMIN decide se a foto entra no reconhecimento.",
      tone: "pending",
      terminal: false,
      adminOnly: true,
    },
    queued: {
      label: "Aguardando Reconhecimento",
      description: "A foto ja pode ser processada pelo worker.",
      nextAction: "Aguardar a conclusao do reconhecimento.",
      tone: "pending",
      terminal: false,
    },
    processing: {
      label: "Processando Reconhecimento",
      description: "A foto esta sendo analisada.",
      nextAction: "Aguardar a conclusao do reconhecimento.",
      tone: "processing",
      terminal: false,
    },
    processed: {
      label: "Reconhecimento Processado",
      description: "A foto terminou o reconhecimento; o outcome nao publica a imagem sozinho.",
      nextAction: "Consultar o outcome e a decisao administrativa aplicavel.",
      tone: "completed",
      terminal: true,
    },
    failed: {
      label: "Falha no Reconhecimento",
      description: "O arquivo foi preservado e exige avaliacao administrativa.",
      nextAction: "ADMIN pode reprocessar, remover ou classificar como foto geral apos inspecao.",
      tone: "failed",
      terminal: true,
      adminOnly: true,
    },
    skipped: {
      label: "Ignorado",
      description: "O reconhecimento atingiu o tempo limite; o arquivo foi preservado.",
      nextAction: "ADMIN pode reprocessar manualmente.",
      tone: "skipped",
      terminal: true,
      adminOnly: true,
    },
  },
  outcome: {
    matched: {
      label: "Match",
      description: "Ha pelo menos uma pessoa reconhecida acima dos limiares aceitos.",
      nextAction: "Aguardar a decisao administrativa de publicacao.",
      tone: "completed",
      terminal: true,
    },
    no_match: {
      label: "Sem Match",
      description: "Ha rosto detectado, mas nenhum candidato foi aceito.",
      nextAction: "ADMIN pode classificar como foto geral ou manter sem publicacao.",
      tone: "pending",
      terminal: true,
      adminOnly: true,
    },
    other: {
      label: "Possível foto geral",
      description: "Nenhum rosto foi detectado na foto.",
      nextAction: "ADMIN pode confirmar foto geral ou remover apos inspecao.",
      tone: "pending",
      terminal: true,
      adminOnly: true,
    },
    general_candidate: {
      label: "Possível foto geral",
      description: "Nenhum rosto foi detectado na foto.",
      nextAction: "ADMIN pode confirmar foto geral ou remover apos inspecao.",
      tone: "pending",
      terminal: true,
      adminOnly: true,
    },
    failed: {
      label: "Falha",
      description: "O resultado tecnico falhou; a foto nao foi publicada.",
      nextAction: "ADMIN pode reprocessar, remover ou classificar como foto geral apos inspecao.",
      tone: "failed",
      terminal: true,
      adminOnly: true,
    },
  },
};

const UNKNOWN_PRESENTATION = {
  label: "Estado atualizado",
  description: "Aguarde a reconciliacao do estado persistido.",
  nextAction: "Atualizar o snapshot autorizado antes de tomar uma acao.",
  tone: "pending",
  terminal: false,
};

const HEALTH_PRESENTATIONS = {
  available: { label: "Disponível", tone: "available" },
  degraded: { label: "Atenção", tone: "degraded" },
  unavailable: { label: "Indisponível", tone: "unavailable" },
  not_configured: { label: "Não configurado", tone: "not_configured" },
};

const UNKNOWN_HEALTH_PRESENTATION = {
  label: "Status desconhecido",
  tone: "not_configured",
};

export const getRecognitionHealthPresentation = (status) =>
  HEALTH_PRESENTATIONS[normalizeStatus(status)] || UNKNOWN_HEALTH_PRESENTATION;

export const getRecognitionStatusPresentation = (kind, status, role) => {
  const presentation = PRESENTATIONS[kind]?.[normalizeStatus(status)] || UNKNOWN_PRESENTATION;

  if (!presentation.adminOnly || role === "ADMIN") return presentation;

  return {
    ...presentation,
    nextAction: "Aguardar a acao administrativa responsavel.",
  };
};

export const getRecognitionStatusLabel = (kind, status, role) =>
  getRecognitionStatusPresentation(kind, status, role).label;
